<div class="card">
  <app-header titulo="Provisao" descricao="Dados de provisoes"></app-header>

  <p-table [value]="provisoes" dataKey="idProv" [(selection)]="provisoesSelecionadas" [loading]="loading" #dt
           [globalFilterFields]="['instancia','idProv', 'cdFornecedorErp','vlProvisao','deHistContabil','cdDocumentoErp']"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[20, 50, 100, 500, 1000]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           currentPageReportTemplate="Provisões selecionadas {{provisoesSelecionadas.length}} | Mostrando de {first} até {last} de {totalRecords} registros"(onPage)="onPageChange($event)" (onFilter)="onFilter($event)" (selectionChange)="onSelectionChange()">
    <ng-template pTemplate="caption">
      <div class="flex">

        <p-multiSelect
          appendTo="body"
          [options]="instancias"
          [filter]="true"
          [style]="{'width':'200px'}"
          optionValue="id"
          optionLabel="nome"
          [(ngModel)]="instanciaSelecionada"
          dataKey="id" inputId="id"
          placeholder="Instância"
          emptyMessage="Nenhuma instância"
          (onChange)="getProvisoes()"
        >

        </p-multiSelect>

        <div class="flex justify-content-center">
          <p-calendar
            [(ngModel)]="rangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            [readonlyInput]="true"
            (onClose)="getProvisoes()"
          />
        </div>
        <div class="flex justify-content-center">
          <button class="ml-3" pButton (click)="sincronizar()" style="font-size: 1.0rem" [loading]="loadingSincronizar"
                  icon="pi pi-arrow-down-right" label="Buscar PIMS"></button>
        </div>
        <div class="flex justify-content-center">
          <button class="ml-3" pButton (click)="integrar()" style="font-size: 1.0rem" [loading]="loadingSincronizar"
                  icon="pi pi-arrow-up-right" label="Enviar ERP"></button>
        </div>
        <div class="flex justify-content-center">
          <button class="ml-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingSincronizar"
                  icon="pi pi-file-excel" label="Exportar"></button>
          <p-splitButton class="ml-3" label="Reversão" icon="pi pi-undo" [model]="itensReversao"/>
        </div>
        <span class="p-input-icon-left ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                     placeholder="Pesquisar"/>
          </span>
        <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getProvisoes()" [loading]="loading"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">

          <p-checkbox [(ngModel)]="selecionados" [binary]="true" (onChange)="selecionarRegistros($event)">
            <ng-template pTemplate="icon">
                    <span>
                     <i *ngIf="iconeCheckbox === 'Nenhum'"
                        class="pi pi-square"></i>
                      <!-- Estado: Parcial -->
                      <i *ngIf="iconeCheckbox === 'Parcial'"
                         class="pi pi-minus"
                         style="color: var(--secondary-color);"></i>

                      <!-- Estado: Todos -->
                      <i *ngIf="iconeCheckbox === 'Todos'"
                         class="pi pi-check"
                         style="color: var(--secondary-color);"></i>
                        </span>
            </ng-template>
          </p-checkbox>
          <span><a style="text-decoration: underline; cursor: pointer" (click)="selectionarTodos()"
                   *ngIf="provisoesSelecionadas.length >= 1 && provisoesSelecionadas.length < provisoes.length">Tudo?</a></span>
        </th>
        <th>ID Provisão</th>
        <th>Instância</th>
        <th>Fazenda</th>
        <th>Dt Provisão</th>
        <th>Vl. Provisão</th>
        <th>Cód. Documento ERP</th>
        <th>Dt. Recebido</th>
        <th>De. Hist. Contabil</th>
        <th>Dt. Integ PIMS</th>
        <th>Dt. Integ ERP</th>
        <th pSortableColumn="fgStatusInteg">
          Status
          <p-sortIcon field="fgStatusInteg"/>
          <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false"
                          [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                          [showAddButton]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status"
                             placeholder="Todos" [filter]="true" optionValue="value" (onChange)="filter($event.value)"
                             optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="clearfiltericon">
            </ng-template>
          </p-columnFilter>
        </th>
        <th>Mensagem</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-provisao>
      <tr>
        <td>
          <p-tableCheckbox [value]="provisao"/>
        </td>
        <td>{{ provisao.idProv }}</td>
        <td>{{ provisao.instancia }}</td>
        <td>{{ provisao.cdFornecedorPims }}</td>
        <td>{{ provisao.dtProvisao }}</td>
        <td>{{ provisao.vlProvisao }}</td>
        <td>{{ provisao.cdDocumentoErp }}</td>
        <td>{{ provisao.dtRecebido }}</td>
        <td>{{ provisao.deHistContabil }}</td>
        <td>{{ provisao.dtIntegPims }}</td>
        <td>{{ provisao.dtIntegErp }}</td>
        <td>
          <app-tag-status [status]="provisao.fgStatusInteg"></app-tag-status>
        </td>
        <td>{{ provisao.deMensagemInteg }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>

  <p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
</div>
